import { render, staticRenderFns } from "./BlogForm.vue?vue&type=template&id=5514a3d4&scoped=true&"
import script from "./BlogForm.vue?vue&type=script&lang=js&"
export * from "./BlogForm.vue?vue&type=script&lang=js&"
import style0 from "./BlogForm.vue?vue&type=style&index=0&id=5514a3d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5514a3d4",
  null
  
)

export default component.exports